import { useCallback, useEffect, useState } from 'react';
import { useSelector } from 'react-redux';

import { CHAT_ONBOARDING_TEXT, CONFIG_MAP, ONBOARDING_COOKIE_NAME_MAP } from './constants';
import { getBuilderChatButtonClicked } from '../../../selectors/builderChat';
import { useApplicationContext } from '../../../utils/withApplicationContext';
import { TChatOnboardingType } from '../types';
import { getChatOnboardingCookie, setChatOnboardingCookie } from '../utils/chatOnboardingCookie';

interface IOnboardingTooltipResult {
  open: boolean;
  onboardingText: string;
  closeHandler: () => void;
}

export const useChatOnboarding = (onboardingType: TChatOnboardingType): IOnboardingTooltipResult => {
  const { config } = useApplicationContext();

  const [open, setOpen] = useState(false);

  const isBuilderChatButtonClicked = useSelector(getBuilderChatButtonClicked);
  const onboardingText = config.get<string>(CHAT_ONBOARDING_TEXT[onboardingType]) ?? '';

  const cookieName = ONBOARDING_COOKIE_NAME_MAP[onboardingType];

  const closeHandler = useCallback(() => {
    setOpen(false);
  }, []);

  useEffect(() => {
    const isOnboardingEnabled = config.get<boolean>(CONFIG_MAP[onboardingType]);

    if (isOnboardingEnabled && !getChatOnboardingCookie(cookieName)) {
      setOpen(true);
      setChatOnboardingCookie(cookieName);
    }
  }, [cookieName, config, onboardingType]);

  useEffect(() => {
    if (onboardingType === 'builder' && open && isBuilderChatButtonClicked) {
      closeHandler();
    }
  }, [isBuilderChatButtonClicked, open, onboardingType, closeHandler]);

  return {
    open,
    onboardingText,
    closeHandler,
  };
};
